import BuildMessage from "app/components/build/Message";
import { useBuild } from "../../lib/BuildContext";
import { PullRequest } from "app/components/build/Header/PullRequest";
import { Commit } from "app/components/build/Header/Commit";
import FriendlyTime from "app/components/shared/FriendlyTime";
import { Author } from "app/components/build/Show/components/Author";

export const BuildMeta = () => {
  const { build } = useBuild();

  return (
    <div className="flex flex-col py-1.5 px-1.5 gap-1 shadow-depth-200 rounded-md mt-[1px] mx-[1px]">
      <div className="flex gap-1 items-center text-sm">
        <span className="flex items-center gap-1">
          <Commit {...build} />
        </span>
        {build.pullRequest && (
          <span>
            (<PullRequest {...build} />)
          </span>
        )}
      </div>

      <div className="text-sm font-medium">
        <BuildMessage
          className="text-inherit focus:text-inherit hover:text-inherit line-clamp-2"
          url={build.commitUrl}
          message={build.message}
        />
      </div>

      <div className="text-xs/5 flex justify-between flex-wrap items-center gap-1">
        <Author {...build} />
        <span className="text-charcoal-500">
          <FriendlyTime value={build.createdAt} capitalized={true} />
        </span>
      </div>
    </div>
  );
};
